export class CreateFertilizerUseCase {
  constructor(api){
    this.api=api
  }
  async execute(farm) {
    const {
      NAME,
      DILUTION,
      COMPOSITION,
      isEspecial,
      NOTE
    }=farm
    const raw = `
      INSERT INTO CROP.FERTILIZER (
        NAME,
        DILUTION,
        COMPOSITION,
        isEspecial,
        NOTE
      )
      VALUES(
        "${NAME}",
        ${DILUTION},
        "${COMPOSITION}",
        ${isEspecial},
        "${NOTE}"
      );
    `
    const resp= await this.api.sql({
      data:{
        sql:raw
      }
    })

    return resp
  }
}
